import { render, staticRenderFns } from "./AddPromoCode.vue?vue&type=template&id=1dbb8f39&"
import script from "./AddPromoCode.vue?vue&type=script&lang=js&"
export * from "./AddPromoCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports